import type { FilterDef } from '../../types/manualDashboard';

type Picks = Record<string, string[]>;

/**
 * What the filter bar shows as picked: the reader's choice, or a filter's
 * default until they change it (the Scorecard opens on MQL).
 */
export function shownFilters(applied: Picks, defs: FilterDef[]): Picks {
  const out: Picks = { ...applied };
  for (const f of defs) {
    if (!(f.key in applied) && f.default?.length) out[f.key] = f.default;
  }
  return out;
}

/**
 * What the board is asked for. An untouched filter is left out, and the server
 * puts its default in. A filter with a default that the reader cleared means
 * every value — sent as all of them, since an empty pick is never sent and the
 * server would read it as untouched and bring the default back.
 */
export function sentFilters(applied: Picks, defs: FilterDef[]): Picks {
  const out: Picks = { ...applied };
  for (const f of defs) {
    const cleared = f.key in applied && applied[f.key].length === 0;
    if (cleared && f.default?.length) out[f.key] = f.options.map((o) => o.value);
  }
  return out;
}

/**
 * Every filter cleared, for "Clear all filters". A filter with a default is
 * written as cleared, not left out, or its default would come straight back.
 */
export function clearedAll(defs: FilterDef[]): Picks {
  return Object.fromEntries(defs.filter((f) => f.default?.length).map((f) => [f.key, []]));
}
